import React, { createContext, useReducer, useContext } from 'react';
import { IQuestionAnwserReponsae } from '../../../model/base/response/question-awnser-respons';
import { ICategoryQuestionAwnserResponse } from '../../../model/base/response/category-question-awnser-response';

interface FAQState {
  faqs: IQuestionAnwserReponsae[];
  categories: ICategoryQuestionAwnserResponse[];
  loading: boolean;
  error: string | null;
}

type FAQAction =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_FAQS'; payload: IQuestionAnwserReponsae[] }
  | { type: 'SET_CATEGORIES'; payload: ICategoryQuestionAwnserResponse[] }
  | { type: 'SET_ERROR'; payload: string | null };

const initialState: FAQState = {
  faqs: [],
  categories: [],
  loading: false,
  error: null,
};

const FAQStateContext = createContext<FAQState | undefined>(undefined);
const FAQDispatchContext = createContext<React.Dispatch<FAQAction> | undefined>(undefined);

function faqReducer(state: FAQState, action: FAQAction): FAQState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_FAQS':
      return { ...state, faqs: action.payload, loading: false };
    case 'SET_CATEGORIES':
      return { ...state, categories: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
}

export function FAQProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(faqReducer, initialState);

  return (
    <FAQStateContext.Provider value={state}>
      <FAQDispatchContext.Provider value={dispatch}>
        {children}
      </FAQDispatchContext.Provider>
    </FAQStateContext.Provider>
  );
}

export function useFAQState() {
  const context = useContext(FAQStateContext);
  if (context === undefined) {
    throw new Error('useFAQState must be used within a FAQProvider');
  }
  return context;
}

export function useFAQDispatch() {
  const context = useContext(FAQDispatchContext);
  if (context === undefined) {
    throw new Error('useFAQDispatch must be used within a FAQProvider');
  }
  return context;
}
